import React from 'react';

interface IIconProps {
    fill?: string;
    width?: number;
    height?: number;
}

export const Paintbrush = ({ fill = '#818998', width = 14, height = 13 }: IIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14 13"
        fill="none"
    >
        <path
            d="M11.063 3.93733L13.9966 1.00375L13.163 0.170166L10.2195 3.11308L8.93266 1.85542C8.72156 1.65004 8.4409 1.53164 8.14648 1.52375C7.85207 1.51586 7.56547 1.61906 7.34366 1.81283C6.26096 2.79344 5.00122 3.55863 3.63192 4.06742L-0.00341797 5.13317V5.57417C0.02028 7.56515 0.83271 9.46545 2.25566 10.8582C3.67861 12.251 5.59588 13.0225 7.58691 13.0035H8.31083L8.46308 12.8973C9.65243 12.1349 10.6392 11.0954 11.3388 9.86804C12.0384 8.64066 12.4299 7.26196 12.4799 5.85008C12.4844 5.68749 12.4551 5.52573 12.3937 5.37509C12.3324 5.22446 12.2404 5.08823 12.1235 4.97508L11.063 3.93733ZM8.10841 2.69833L11.3033 5.81392C11.2856 6.40872 11.1963 6.99923 11.0373 7.57267L6.96566 3.60833C7.36154 3.32428 7.74294 3.02057 8.10841 2.69833ZM7.93691 11.8246H7.58691C6.72733 11.8239 5.87632 11.6536 5.08266 11.3235C6.10216 10.8113 6.97488 10.0486 7.619 9.10683L7.92116 8.6635L6.94758 8.00083L6.64541 8.44475C6.11285 9.22142 5.39191 9.85024 4.55008 10.2723L3.83317 10.6328C3.25027 10.2225 2.74053 9.71711 2.32525 9.13775C3.27699 8.81618 4.14519 8.28673 4.86683 7.58783L4.04375 6.74492C3.39198 7.37666 2.59642 7.8405 1.72558 8.0965C1.42357 7.43896 1.24162 6.7327 1.18833 6.01108L3.96208 5.19792C4.66361 4.97291 5.33437 4.66134 5.95883 4.27042L10.5736 8.76208C9.96338 9.98617 9.05755 11.0388 7.93808 11.8246H7.93691Z"
            fill={fill}
        />
    </svg>
);
